<template>
    <div>
        <template v-if="messageOnly"> <slot>Processing</slot>{{ dots }} </template>
        <template v-else>
            <Dialog v-model:visible="visible" :style="{ width: '300px' }" :modal="true" class="p-fluid dialog-header" :closable="false">
                <h4 class="text-center">Processing{{ dots }}</h4>
                <BeatLoader class="m-auto" />
            </Dialog>
        </template>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

defineProps({
    messageOnly: {
        type: Boolean,
        default: false,
    },
});

const visible = ref(true);
const dots = ref('.');

onMounted(() => {
    // If its message only then show dots loader
    showLoadingDots();
});

const showLoadingDots = () => {
    // Function to update loader with dots
    function updateLoader() {
        dots.value += '.';
        if (dots.value.length > 3) {
            dots.value = '.';
        }
    }
    // Update loader every 500 milliseconds
    setInterval(updateLoader, 500);
};
</script>
